import Box from '@mui/material/Box';
import { useTheme } from '@mui/material/styles';
import { RichText } from '@sitecore-jss/sitecore-jss-nextjs';
import { StNextIcon } from '../shared/NextImage.styles';
import MyProfileCollapse from '../../../public/MyProfileChevronDown.svg';
import MyProfileExpand from '../../../public/MyprofileChevronRight.svg';
import UiHeading from '../shared/Heading';
import UiText from '../shared/Typography/UiText';

const MyProfileHeader = (props: any): JSX.Element => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        display: 'flex',
        paddingTop: '1.5rem',
        color: theme.palette.neutral8.main,
      }}
      id="my-profile-header"
      className="ui-my-profile-header"
    >
      <Box sx={{ flex: 2 }}>
        <UiHeading size="h2">{props?.fields?.heading}</UiHeading>
        <UiText size="body1">
          <RichText field={props?.fields?.content} />
        </UiText>
      </Box>
      {!props.showForm ? (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            minWidth: '50px',
            cursor: 'pointer',
          }}
          onClick={() => props.handleEdit(true)}
        >
          {/* <NextImage field={props?.fields?.editIcon} width={43} height={43} /> */}
          <StNextIcon
            suppressHydrationWarning
            alt="my-profile-expand"
            src={MyProfileExpand}
            width={43}
            height={43}
            overrideIconColor={theme.palette.primary.main}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'flex-start',
            minWidth: '50px',
            cursor: 'pointer',
          }}
          onClick={() => props.handleEdit(false)}
        >
          <StNextIcon
            suppressHydrationWarning
            alt="my-profile-collapse"
            src={MyProfileCollapse}
            width={43}
            height={43}
            overrideIconColor={theme.palette.primary.main}
          />
        </Box>
      )}
    </Box>
  );
};

export default MyProfileHeader;
